export const RETRIEVING_MEMBER_BADGES = 'Retrieving Member Badges';
export const UPDATING_MEMBER_BADGES = 'Updating Member Badges';
